import { APIClient } from '@api/index';

import { BrandsParams } from '../types';

const API_URL = 'catalog/brands';

const QUERY_KEY_BRANDS = 'brands';

export const getBrands = (apiClient: APIClient) => (data: BrandsParams) => ({
    key: [QUERY_KEY_BRANDS, data],
    fetch: () =>
        apiClient.post(`${API_URL}:search`, {
            data,
        }),
});

export const getBrand =
    (apiClient: APIClient) =>
    ({ id }: { id: number | string }) => ({
        key: [QUERY_KEY_BRANDS, id],
        fetch: () => apiClient.get(`${API_URL}/${id}`),
    });
